import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Select, Store } from '@ngxs/store';
import {
    AccountService,
    AuthorizationActions,
    ModulesSelectors,
    ValidationsService,
} from '@serviceos-ng/core';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';

@Component({
    selector: 'serviceos-web-recover-password',
    templateUrl: './recover-password.component.html',
    styleUrls: ['./recover-password.component.scss'],
})
export class RecoverPasswordComponent implements OnInit {
    
    @Select(ModulesSelectors.getModuleConfigText('auth'))
    moduleAuthTexts$!: Observable<any>;

    @Output()
    public changeScreenEvent = new EventEmitter();
    
    public recoverPasswordForm!: FormGroup;
    public emailSent = false; 
    public formErrorMessage = '';
    public isRepeatPasswordMatch = true;
    private recoverPasswordToken = '';
    public showLocalLoader = false;

    constructor(
        private fb: FormBuilder,
        private store: Store,
        private _validationService: ValidationsService,
        private _accountService: AccountService,
        private route: ActivatedRoute
    ) {
        
    }

    ngOnInit(): void {
        this.recoverPasswordForm = this.fb.group({
            password: [
                '',
                [
                    Validators.required,
                    Validators.pattern(
                        this._validationService.getPattern(
                            'register',
                            'password'
                        )
                    ),
                ],
            ],
            repeat_password: [
                '',
                [
                    Validators.required,
                    Validators.pattern(
                        this._validationService.getPattern(
                            'register',
                            'password'
                        )
                    ),
                ],
            ],
        });

        this.route.params.subscribe((params) => {
            if (params?.id) {
                this.recoverPasswordToken = params.id;
            }
        });
        
    }

    public processForm() {
        this.isRepeatPasswordMatch = true;

        if (this.recoverPasswordForm.valid) {
            const formValue = this.recoverPasswordForm.value;

            if (formValue.password !== formValue.repeat_password) {
                this.isRepeatPasswordMatch = false;
            } else {
                const formData = {
                    token: this.recoverPasswordToken,
                    password: formValue.password,
                    confirm_password: formValue.repeat_password,
                };
    
                this.showLocalLoader = true;
    
                this.store
                    .dispatch(new AuthorizationActions.ResetPassword(formData))
                    .pipe(
                        finalize(() => {
                            this.showLocalLoader = false;
                        })
                    )
                    .subscribe(
                        (res) => {
                            this.isRepeatPasswordMatch = true;
                            this.emailSent = true;
                        },
                        (error) => {
                            this.formErrorMessage = error?.error[0]?.message;
                        }
                    );
            }
            
        }
    }

    /**
     * Geter for field in recover password form
     */
    get password() {
        return this.recoverPasswordForm.get('password');
    }

    /**
     * Geter for field in recover password form
     */
    get repeat_password() {
        return this.recoverPasswordForm.get('repeat_password');
    }

    public changeScreenHandler(screen) {
        this.changeScreenEvent.emit(screen);
    }
}
